import {
  CareJourneySection,
  CareModeProvider,
  CareModesSection,
  FooterSection,
  HeaderSection,
  HeroSection,
  MobileCallBar,
  ServicesSection,
  TrustSection,
  VisitSection,
} from './domains/clinic';
import { DemoPreviewBanner } from './shared/components/DemoPreviewBanner';
import { JmrSquaredAttribution } from './shared/components/JmrSquaredAttribution';

export function App() {
  return (
    <CareModeProvider>
      <div className="min-h-screen overflow-x-hidden bg-bone text-ink">
        <DemoPreviewBanner />
        <HeaderSection />
        <main>
          <HeroSection />
          <CareJourneySection />
          <CareModesSection />
          <ServicesSection />
          <TrustSection />
          <VisitSection />
        </main>
        <FooterSection />
        <JmrSquaredAttribution />
        <MobileCallBar />
      </div>
    </CareModeProvider>
  );
}
